import { Box, Link } from "@mui/material";
import { ArrowNarrowLeftIcon, Button, Typography } from "components";
import { gray } from "configs/colors";
import { useNavigate } from "react-router-dom";

import textBackground from "../../assets/images/textBackground.png";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box paddingY="96px" display="flex" height="100%">
      <Box
        paddingX="56px"
        display="flex"
        justifyContent="center"
        alignSelf="center"
        flex="1"
      >
        <Box
          alignItems="end"
          alignSelf="center"
          textAlign="center"
          sx={{
            backgroundImage: `url(${textBackground})`,
            width: "880px",
            height: "356px",
          }}
          display="flex"
          justifyContent="center"
        >
          <Box>
            <Typography type="DisplayXL" color={gray[900]} fontWeight={600}>
              We lost this page
            </Typography>
            <Typography type="TextXL" color={gray[600]} mt="21px" mb="48px">
              This contract cannot be opened because the document has been
              canceled.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
